import {useCookies} from 'react-cookie'
import {COOKIE_EXPIRATION} from 'shared/constant/COOKIE_EXPIRATION'

const useConfrimCookie = () => {
	const cookieName = 'ACC1'
	const [cookie, setCookie, removeCookie] = useCookies([cookieName])

	const createCookie = (token) => {
		setCookie(cookieName, token, {
			path: '/',
			sameSite: 'none',
			secure: true,
			expires: new Date(Date.now() + COOKIE_EXPIRATION.FIVE_MINUTES),
		})
	}

	const deleteCookie = () => {
		removeCookie(cookieName, {path: '/'})
	}

	return [cookie[cookieName], createCookie, deleteCookie]
}

export default useConfrimCookie
